// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { CreateWizardInvoiceResponseFragment } from '../../fragments/generated/create-wizard-invoice-response.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateWizardInvoiceMutationVariables = Types.Exact<{
  request: Types.InputMaybe<Types.CreateWizardInvoiceRequestDtoInput>;
}>;


export type CreateWizardInvoiceMutationResult = { __typename?: 'Mutation', createWizardInvoice: { __typename?: 'CreateWizardInvoiceResponseDTO', invoiceId: number, bolloRequired: boolean } };

export const CreateWizardInvoiceGql = gql`
    mutation CreateWizardInvoice($request: CreateWizardInvoiceRequestDTOInput) {
  createWizardInvoice(request: $request) {
    ...CreateWizardInvoiceResponse
  }
}
    ${CreateWizardInvoiceResponseFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateWizardInvoiceInjectable extends Apollo.Mutation<CreateWizardInvoiceMutationResult, CreateWizardInvoiceMutationVariables> {
    override document = CreateWizardInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */